import { ModuleLayout, NavigationItem } from '@/components/ModuleLayout'
import {
  LayoutDashboard,
  BookOpenText,
  FileText,
  DollarSign,
  Scale,
  List,
} from 'lucide-react'
import { ShortcutProvider } from '@/contexts/ShortcutContext'
import { ShortcutHelpOverlay } from '@/components/ui/shortcut-help-overlay'
import { ShortcutFooterBar } from '@/components/ui/shortcut-footer-bar'

const navigation: NavigationItem[] = [
  {
    name: 'Panel Principal',
    href: '/accounting/dashboard',
    icon: LayoutDashboard,
  },
  {
    name: 'Asientos',
    href: '/accounting/operations',
    icon: BookOpenText,
  },
  {
    name: 'Plan de Cuentas',
    href: '/accounting/categories',
    icon: List,
  },
  {
    name: 'Saldos',
    href: '/accounting/balances',
    icon: Scale,
  },
  {
    name: 'Reportes',
    href: '/accounting/reports',
    icon: FileText,
  },
]

export function AccountingLayout({ children }: { children: React.ReactNode }) {
  return (
    <ShortcutProvider>
      <ModuleLayout
        moduleName="Contabilidad"
        moduleIcon={DollarSign}
        moduleColor="from-purple-500 to-purple-600"
        navigation={navigation}
        footer={<ShortcutFooterBar />}
      >
        {children}
      </ModuleLayout>
      <ShortcutHelpOverlay />
    </ShortcutProvider>
  )
}
